import { createTheme } from '@mui/material/styles'
const MaterialUITheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#5f80eb',
      contrastText: '#fff',
    },
    secondary: {
      main: '#ffb031',
      contrastText: '#fff',
    },
    success: {
      main: '#32bea6',
    },
    error: {
      main: '#ff4c04',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#000000',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: [
      'Poppins',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#606060',
          lineHeight: '1.8em',
        },
        tooltipArrow: {
          backgroundColor: '#606060',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
})

export default MaterialUITheme
